import React, { memo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import Upload from '@mui/icons-material/Upload';
import { pillButtonSx } from '../dashboard/styles';

const SwaggerFilesHeader: React.FC<{ onUpload: () => void }> = ({ onUpload }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 2, flexWrap: 'wrap' }}>
    <Box>
      <Typography component="h1" sx={{ fontSize: 32, fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.15 }}>
        Swagger files
      </Typography>
      <Typography sx={{ mt: 0.75, color: 'text.secondary', fontSize: 14, maxWidth: 640 }}>
        OpenAPI specs available to the{' '}
        <Link component={RouterLink} to="/mapping-document">
          mapping document generator
        </Link>
        . Upload JSON files.
      </Typography>
    </Box>
    <Button variant="contained" startIcon={<Upload />} onClick={onUpload} sx={pillButtonSx}>
      Upload file
    </Button>
  </Box>
);

export default memo(SwaggerFilesHeader);
